// @flow

import type {Tag, RenderTag} from '@stripe-internal/markdoc';
import {isMarkdocAstTag} from 'docs/util';

export const findMarkdocTag = (
  tags: Array<RenderTag>,
  predicate: (tag: Tag) => boolean,
): ?Tag => {
  for (const tag of tags) {
    if (isMarkdocAstTag(tag) && predicate(tag)) {
      return tag;
    }
  }
};
